import useSWR from 'swr'
import { getStoryBySlug, useStoryblokState } from '@cinch-nx/data-storyblok'
import { type SearchPageContent } from '@cinch-nx/data-search'
import { getStoryblokSlugFromUrl } from '../../utils'
import { useSearchStore } from '..'
import { useRouter } from 'next/router'

const fetcher = async ({
  slug,
  isInsideStoryblok,
}: {
  slug: string
  isInsideStoryblok: boolean
}) => {
  const args: Parameters<typeof getStoryBySlug>[1] = {
    version: isInsideStoryblok ? 'draft' : 'published',
    ...(isInsideStoryblok && { cv: Date.now() }),
  }

  return await getStoryBySlug<SearchPageContent>(slug, args, { strict: false })
}

export function useStoryblokData() {
  const isInsideStoryblok = useSearchStore<boolean>((s) => s.isInsideStoryblok)

  const { asPath } = useRouter()

  const slug = getStoryblokSlugFromUrl(asPath)

  const shouldFetch = slug !== 'search/' && slug !== null

  // See: https://swr.vercel.app/docs/conditional-fetching#conditional
  // and: https://swr.vercel.app/docs/arguments#multiple-arguments
  // For information on the advanced usage used here
  const { data, error, isLoading, isValidating } = useSWR(
    shouldFetch ? [slug, isInsideStoryblok] : null,
    ([slug, isInsideStoryblok]) => fetcher({ slug, isInsideStoryblok }),
  )

  const story = useStoryblokState({
    story: data || undefined,
    enableBridge: isInsideStoryblok,
  })

  const content = story?.content
  return {
    headingOverride: content?.HeadingOverride,
    intro: content?.Intro?.[0],
    faqs: content?.FAQ?.[0],
    outro: content?.Outro,
    seo: content?.SEO?.[0],
    isLoading,
    isValidating,
    error,
  }
}
